var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.isDropdownVisible ? _c('div', {
    staticClass: "absolute right-0 z-50 w-4/6 bg-white rounded-lg shadow top-16",
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "flex items-center justify-between w-full p-2 px-3"
  }, [_vm._m(0), _c('div', [_c('span', {
    staticClass: "cursor-pointer",
    on: {
      "click": _vm.handleClose
    }
  }, [_c('i', {
    staticClass: "text-gray-500 fa-solid fa-xmark"
  })])])]), _c('div', {
    staticClass: "w-full mt-2 mb-3"
  }, [_c('label', {
    staticClass: "mx-3 mb-2"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "mx-3 mb-2"
  }, [_c('InputDropdown', {
    attrs: {
      "options": _vm.statusOptions,
      "defaultText": "All Status"
    },
    model: {
      value: _vm.status,
      callback: function ($$v) {
        _vm.status = $$v;
      },
      expression: "status"
    }
  })], 1)]), _c('div', {
    staticClass: "flex justify-start gap-3 px-3 mt-3 mb-3"
  }, [_c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "primary",
      "size": "base"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v(" Filter ")]), _c('Button', {
    staticClass: "px-6 py-2",
    attrs: {
      "color": "alternative",
      "variant": "outlined",
      "size": "base"
    },
    on: {
      "click": _vm.resetFilter
    }
  }, [_vm._v(" Reset ")])], 1)]) : _vm._e()]);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h5', {
    staticClass: "mt-2 text-base font-light text-gray-500"
  }, [_vm._v("Filter")])]);
}]

export { render, staticRenderFns }